import { Button } from "@synthesis/shared-ui";
import type { ComponentProps } from "react";
import { useNavigate } from "@tanstack/react-router";
import IconPlus from "@synthesis/shared-icons/IconPlus";
import { useClientType } from "../../../shared/hooks/use-client-type";
import { useUserRoles } from "../../../shared/hooks/use-user-roles";

type CreateApplicationButtonProps = ComponentProps<typeof Button> & {
  className?: string;
};

export const CreateApplicationButton = ({ className, ...props }: CreateApplicationButtonProps) => {
  const navigate = useNavigate();
  const clientType = useClientType();
  const roles = useUserRoles();

  const handleClick = () => {
    navigate({ to: "/applications/create" });
  };

  if (clientType !== "external" || !roles.isExternalApplicant) {
    return null;
  }

  return (
    <Button className={className} size="sm" theme="primary" leftIcon={<IconPlus className="size-5" />} {...props} onClick={handleClick}>
      Создать заявку
    </Button>
  );
};
